import api from '../index'

const userMgmt = {
  listUserMgmt: async () => await api.get('accepted'),
  findUserMgmt: async (params) => await api.get(`accepted${params}`)
}

export default userMgmt
